module.exports = __webpack_public_path__ + "fonts/35b79d0db1f4fd4494306613a24db3f7-SocialBrands-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SocialBrands-Regular.woff
// module id = 358
// module chunks = 0